import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();
export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ primary_color: '#1565c0', secondary_color: '#e53935', theme_mode: 'light', school_name: 'School Management System' });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/settings`)
      .then(res => { if (res.data.success && res.data.data) setSettings(res.data.data); })
      .catch(() => {});
  }, []);

  const refreshSettings = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/settings`);
      if (res.data.success) setSettings(res.data.data);
    } catch {}
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
